import { render, staticRenderFns } from "./PendingRegistrations.vue?vue&type=template&id=0760108f"
import script from "./PendingRegistrations.vue?vue&type=script&lang=js"
export * from "./PendingRegistrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports